import { Component, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { isNumber } from '../../models/utils';

@Component({
    standalone: false,
    selector: 'res-pager',
    templateUrl: './pager.component.html',
    styleUrls: ['./pager.component.scss']
})
export class PagerComponent implements OnChanges {
    public static itemsOnPage = 100;
    @Input() pagerTemplate: TemplateRef<any>;
    @Input() startIndex = 0;
    @Input() totalItems = 0;
    @Input() loadDataCallback: (startIndex: number, count: number) => void;
    @Input() pagerCustomCallback: (startIndex: number) => void;
    @Input() pagerAfterLoadCustomCallback: () => void;
    @Input() automationId = 'pager';
    @Input() pagerName: string;
    @Input() pagerDisabled: boolean;
    @Input() isRefreshIconHidden: boolean;
    endIndex = 0;
    totalPages = 1;
    currentPage = 1;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes) {
            if (changes.totalItems || changes.startIndex) {
                if (!isNumber(this.totalItems)) {
                    this.totalItems = 0;
                }
                if (!isNumber(this.startIndex)) {
                    this.startIndex = 0;
                }
                if (this.pagerDisabled) {
                    this.currentPage = 1;
                    this.totalPages = 1;
                    this.startIndex = 0;
                    this.endIndex = this.totalItems;
                } else {
                    this.totalPages = Math.ceil(this.totalItems / PagerComponent.itemsOnPage);
                    this.totalPages = Math.max(this.totalPages, 1);
                    this.currentPage = Math.ceil(this.startIndex / PagerComponent.itemsOnPage) + 1;
                    this.currentPage = Math.max(this.currentPage, 1);
                    this.currentPage = Math.min(this.currentPage, this.totalPages);
                    this.endIndex = Math.min(this.startIndex + PagerComponent.itemsOnPage, this.totalItems);
                }
            }
        }
    }

    loadData(page?: string): void {
        if (this.loadDataCallback) {
            let nextPage: number = this.currentPage || 1;
            if (page) {
                switch (page) {
                    case 'first': nextPage = 1; break;
                    case 'previous': nextPage--; break;
                    case 'next': nextPage++; break;
                    case 'last': nextPage = this.totalPages || 1; break;
                }
            }
            nextPage = Math.max(nextPage, 1);
            nextPage = Math.min(nextPage, this.totalPages);
            this.startIndex = (nextPage - 1) * PagerComponent.itemsOnPage;
            if (this.pagerCustomCallback) {
                this.pagerCustomCallback(this.startIndex);
            } else {
                this.loadDataCallback(this.startIndex, PagerComponent.itemsOnPage);
            }
            if (this.pagerAfterLoadCustomCallback) {
                this.pagerAfterLoadCustomCallback();
            }
        }
    }
}
